import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './gallery.reducer';

export const GalleryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const galleryEntity = useAppSelector(state => state.gallery.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="galleryDetailsHeading">
          <Translate contentKey="xtdtApp.gallery.detail.title">Gallery</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{galleryEntity.id}</dd>
          <dt>
            <span id="tieuDe">
              <Translate contentKey="xtdtApp.gallery.tieuDe">Tieu De</Translate>
            </span>
          </dt>
          <dd>{galleryEntity.tieuDe}</dd>
          <dt>
            <span id="thuTu">
              <Translate contentKey="xtdtApp.gallery.thuTu">Thu Tu</Translate>
            </span>
          </dt>
          <dd>{galleryEntity.thuTu}</dd>
        </dl>
        <Button tag={Link} to="/gallery" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gallery/${galleryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GalleryDetail;
